import { MPCA } from '../../domain/mpca';
import { ProcessTechnique } from '../../domain/process-technique';
import { mapper } from '../../tools/mapping/mapper';
import { MPCAEntity, ProcessTechniqueEntity } from '../entity';
import type { AppDB } from '../db';

export class ProcessTechniqueRepository {
    constructor(private readonly database: AppDB) {}


    async clearProcessTechniqueById(ids: number[]) {
        await this.database.processTechniques.where('Id').anyOf(ids).toArray(async phe => {
            for (let i = 0; i < phe.length; i++) {
                if (phe && phe[i].Id !== undefined) {
                    await this.database.processTechniques.where('Id').equals(phe[i].Id!).delete();
                }
            }
        })
    }

    async getProcessTechniqueByIdWithChildren(id: number) {
        return await this.database.processTechniques.where('Id').equals(id).first(async pte => {
            const pt = mapper.map(pte, ProcessTechniqueEntity, ProcessTechnique);
            if (pte?.MPCAId) {
                const mpcae = await this.database.getMPCAEntityById(pte?.MPCAId);
                const mpca = mapper.map(mpcae, MPCAEntity, MPCA);
                pt.Mpca = mpca;
            }

            return pt;
        });
    }

    async attachProcessTechnique(processTechnique: ProcessTechnique, processId: number) {
        let processTechniqueId: number;
        const pte = mapper.map(processTechnique, ProcessTechnique, ProcessTechniqueEntity);

        const pe = await this.database.getProcessEntityById(processId);
        processTechniqueId = await this.database.processTechniques.add(pte);
        await this.database.process.update(processId, {
            ProcessTechniqueIds: pe?.ProcessTechniqueIds ? [...pe.ProcessTechniqueIds, processTechniqueId] : [processTechniqueId]
        });

        if (processTechnique.Mpca) {
            await this.database.attachMPCAToProcess(processTechnique.Mpca, processTechniqueId);
        }

        return processTechniqueId;
    }
}
